import { useRelevantQueryParams } from '@frontend/common';
import { useModals } from '@frontend/modal';
import { useAccountRepository, useLicenseRepository } from '@frontend/repository';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/store';
import { useIsMount } from '../../../utils/hooks';

export const useUrns = () => {
    const { openModal } = useModals();
    const { currentAccount } = useAccountRepository();
    const { functionalities } = useLicenseRepository();
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state as { functionalityId?: string } | null;
    const formId = 'nivaliz-transaction-form';
    const [activeTab, setActiveTab] = useState<string>('all');
    const dispatch = useAppDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const isMount = useIsMount();

    const data: { [key: string]: any } = { ...useRelevantQueryParams(['tab']) };
    const functionalityId = locationState?.functionalityId ?? searchParams.get('functionalityId');
    const functionality = useMemo(() => {
        if (!functionalityId) return null;
        return functionalities.find((f) => f.id === functionalityId) ?? null;
    }, [functionalities, functionalityId]);

    useEffect(() => {
        if (isMount) {
            return;
        } else {
            setSearchParams(
                (prev) => {
                    const params = new URLSearchParams(prev);
                    params.set('tab', activeTab);
                    return params;
                },
                { state: locationState ?? undefined }
            );
        }
    }, [activeTab]);

    const functionalityWizardId = functionality?.wizard_id ?? null;

    const exportData = useMemo(() => {
        return data;
    }, [searchParams, activeTab]);

    return {
        openModal,
        currentAccount,
        navigate,
        location,
        formId,
        activeTab,
        setActiveTab,
        dispatch,
        exportData,
        functionality,
        functionalityWizardId
    };
};
